/**
 * Generated runtime TestId mirror for frontend/src/pages/analytics/CompareGrants.tsx.
 * DO NOT EDIT MANUALLY — re-run scripts/generate-testid-constants.py.
 *
 * Runtime mirror — same values as frontend/e2e/helpers/testids/. Help maps
 * under frontend/src/locales/ import this module to express computed-property
 * keys (e.g. `[XxxTestIds.fooBar]: '...'`).
 */

import type { TestIdPrefix } from "./types.ts";

export const CompareGrantsTestIds = {
  cardTitleCommonCount: "card-title-common-count",
  cardTitleCommonGrants: "card-title-common-grants",
  cardTitleOnlyInA: "card-title-only-in-a",
  cardTitleOnlyInACount: "card-title-only-in-a-count",
  cardTitleOnlyInB: "card-title-only-in-b",
  cardTitleOnlyInBCount: "card-title-only-in-b-count",
  cardTitleSelectIdentities: "card-title-select-identities",
  colCommonEnforcementObject: "col-common-enforcement-object",
  colCommonOperation: "col-common-operation",
  colCommonTargetSystem: "col-common-target-system",
  colCommonValidUntil: "col-common-valid-until",
  colOnlyAEnforcementObject: "col-only-a-enforcement-object",
  colOnlyAOperation: "col-only-a-operation",
  colOnlyATargetSystem: "col-only-a-target-system",
  colOnlyAValidUntil: "col-only-a-valid-until",
  colOnlyBEnforcementObject: "col-only-b-enforcement-object",
  colOnlyBOperation: "col-only-b-operation",
  colOnlyBTargetSystem: "col-only-b-target-system",
  colOnlyBValidUntil: "col-only-b-valid-until",
  comboboxIdentityA: "combobox-identity-a",
  comboboxIdentityB: "combobox-identity-b",
  linkEnforcementObject: (grant_accessId: string) => `link-enforcement-object-${grant_accessId}`,
  linkEnforcementObjectPrefix: () => "link-enforcement-object-" as TestIdPrefix,
  linkTargetSystem: (grant_accessId: string) => `link-target-system-${grant_accessId}`,
  linkTargetSystemPrefix: () => "link-target-system-" as TestIdPrefix
} as const;
